<div class="actions">
	<app-button
		appearance="secondary"
		size="s"
		[isDisabled]="openedDropdown() === dropdownVariantEnum.POST_TRADING_INFO"
		[tuiDropdownMinHeight]="600"
		[tuiDropdownMaxHeight]="600"
		[tuiDropdown]="postTradingInfo"
		[tuiDropdownManual]="openedDropdown() === dropdownVariantEnum.POST_TRADING_INFO"
		(clicked)="toggleDropdown(dropdownVariantEnum.POST_TRADING_INFO)"
	>
		{{ 'postTrading.infoText' | translate }}
	</app-button>
</div>

<ng-template #postTradingInfo>
	<div
		appClickOutside
		(clickOutside)="onClickOutside()"
	>
		<app-post-trading-event-info
			[postTradingEvent]="event()"
			(closeDropdown)="toggleDropdown(null)"
		/>
	</div>
</ng-template>
